export const ADMIN_ROLE = "admin";
export const MANAGER_ROLE = "manager";

export const address = {
  streetAddress: "EPS4743 - 13495 Central Ave",
  city: "Surrey",
  province: "BC",
  country: "Canada",
  postalCode: "V3T 0K2"
};

export const invoiceValidUnits = ["kWh", "suite", "location"];
export const rateValidUnits = ["kWh", "suite", "location", "entitlement"];

// BILLING TYPES
export const BILLABLE = "billable";
export const CREDIT = "credit";
export const PARTIAL = "partial";

// default locationId
export const CIVIC_PLAZA = "CivicPlaza";

export const Months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export const downloadBaseUrl =
  window.location.host === "localhost:3000"
    ? "http://localhost:3001"
    : window.location.origin;



// WEBPACK FOOTER //
// ./src/constants.js